var isSendLead = false;
function sendLeadApp(country, language, name, phone, email, body, type, subject, product, variant, extras, size, legal, marketing) {

  if (isSendLead) {
    return;
  }

  isSendLead = true;

  var params = 'country=' + encodeURIComponent(country) +
              '&language=' + encodeURIComponent(language) +
              '&name=' + encodeURIComponent(name) +
              '&phone=' + encodeURIComponent(phone) +
              '&email=' + encodeURIComponent(email) +
              '&body=' + encodeURIComponent(body) +
              '&type=' + type +
              '&subject=' + encodeURIComponent(subject) +
              '&product=' + encodeURIComponent(product) +
              '&variant=' + encodeURIComponent(variant) +
              '&size=' + encodeURIComponent(size) +
              '&extras=' + encodeURIComponent(extras) +
              '&legal=' + encodeURIComponent(legal) +
              '&marketing=' + encodeURIComponent(marketing);

    var xhr = new XMLHttpRequest();
    xhr.open('GET', ntsapps + 'apps/lead/insert?' + params, false);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

  try {
    xhr.send(); // Enviar la solicitud
  } catch (e) {
    console.error('Request failed:', e);
  } finally {
    isSendLead = false;  // Restablecer la bandera
  }
}

(function() {
  'use strict';

  function wishlistRegisteredAlertMessage() {
    return typeof themeWishlistRegisteredAlert !== 'undefined'
      ? themeWishlistRegisteredAlert
      : 'Debes estar registrado';
  }

  function initHeaderWishlistFavoritesLink() {
    document.querySelectorAll('.header-actions__wishlist-link--guest').forEach(btn => {
      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        alert(wishlistRegisteredAlertMessage());
      });
    });
  }

  function initWishlists() {
    var wishlistBtns = document.querySelectorAll('.wishlist-btn');
    if (!wishlistBtns.length) {
      return;
    }

    wishlistBtns.forEach(wishlistBtn => {
      wishlistBtn.addEventListener('click', (ev) => {
        ev.preventDefault();
        let customerId = wishlistBtn.dataset.customer;
        let productId = wishlistBtn.dataset.product;

        if (!customerId) {
          alert(wishlistRegisteredAlertMessage());
          return;
        }

        if (wishlistBtn.classList.contains("selected")) {
          fetch(ntsapps+'apps/wishlist/remove?customerId='+customerId+'&productId='+productId)
          .then(response => response.json())
          .then(data => {
            wishlistBtn.classList.remove("selected");
            document.querySelector('.list-item-wishlist-'+productId).remove();
          });
        } else {
          fetch(ntsapps+'apps/wishlist/insert?customerId='+customerId+'&productId='+productId)
          .then(response => response.json())
          .then(data => {
            wishlistBtn.classList.add("selected");
          });
        }

      });
    });

    const wishlistBtnsAddCart = document.getElementById('js-add-cartitem-add');
    if (wishlistBtnsAddCart) {
      wishlistBtnsAddCart.addEventListener('click', (ev) => {
        ev.preventDefault();
        let customerId = ev.target.dataset.customer;
        let productId = ev.target.dataset.product;

        if (!customerId) {
          alert(wishlistRegisteredAlertMessage());
          return;
        }

        fetch(ntsapps+'apps/wishlist/insert?customerId='+customerId+'&productId='+productId)
        .then(response => response.json())
        .then(data => {
          const addWishlistModal = document.getElementById('PopupModal-addWishlist');
          if (addWishlistModal?.closeDialog) addWishlistModal.closeDialog();
        });

      });
    }

    const cancelBtnsAddCart = document.getElementById('js-cancel-cartitem-add');
    if (cancelBtnsAddCart) {
      cancelBtnsAddCart.addEventListener('click', (ev) => {
        ev.preventDefault();
        const addWishlistModal = document.getElementById('PopupModal-addWishlist');
        if (addWishlistModal?.closeDialog) addWishlistModal.closeDialog();
      });
    }
  }

  function init() {
    initHeaderWishlistFavoritesLink();
    initWishlists();
  }

  init();
})();
